class ScrollAnimator {
  findPos(obj) {
    var curtop = 0;
    if (obj.offsetParent) {
      do {
        curtop += obj.offsetTop;
      } while (obj = obj.offsetParent);
      return curtop;
    }
  }

  scrollToHelper(to, duration) {
    this.start = window.scrollY;
    this.change = to - this.start;
    this.currentTime = 0;
    this.increment = 20;
    this.duration = duration;

    window.requestAnimationFrame(() => this.scroll());
  }

  scroll(duration) {
    this.currentTime += this.increment;
    let val = this.ease(this.currentTime, this.start, this.change, this.duration);
    window.scrollTo(0, val);
    if (this.currentTime < this.duration) {
      window.requestAnimationFrame(() => this.scroll());
    }
  }

  ease(t, b, c, d) {
    t /= d / 2;
    if (t < 1) return c / 2 * t * t + b;
    t--;
    return -c / 2 * (t * (t - 2) - 1) + b;
  }

  animate(func, inc) {
    setTimeout(() => {
      window.requestAnimationFrame(func);
    }, inc);
  }

  scrollTo(element, duration = 500, padding = 0) {
    this.scrollToHelper(this.findPos(element) - padding, duration);
  }

  scrollToTop() {
    this.scrollToHelper(0, 500);
  }
}

export default new ScrollAnimator();